// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1hwhJ","rootSmall":"AddTileButton_rootSmall__21F71"};